export function scrollToTranscript(questionId: string): void {
  document.getElementById(`transcript-q-${questionId}`)?.scrollIntoView({ behavior: 'smooth' });
}

export function verdictColor(verdict: string | null): string {
  switch (verdict) {
    case 'pass':
      return 'text-green-600';
    case 'fail':
      return 'text-red-600';
    default:
      return 'text-yellow-600';
  }
}

export function getScoreColor(score: number): string {
  if (score >= 4) return 'text-green-600';
  if (score >= 3) return 'text-yellow-600';
  return 'text-red-600';
}
